import angular from 'angular'
import { iaRoutes } from './ia.routes'

const module = angular
  .module('deskfy.ia', [])
  .config(iaRoutes)

export const iaModule = module
